export default "__VITE_ASSET__19874702__"